module.exports = __webpack_public_path__ + "img/buyercentre.0be2778.png";